/**
 * Heading Content module
 *
 * Large headline with optional copy
 */

// Deps
import { createComponent } from "react-fela";
import { gutters } from "~/styleguide";
import { textStyles, fonts } from "~/styleguide/typography";
import { fluid } from "~/styleguide/utils";

import { ContentMaxWidth } from "~/components/layout/max-width";

export default function HeadingContent({ block }) {
    const { heading, copy, anchor_id } = block;

    if (!copy && !heading) return null;

    return (
        <Container id={anchor_id} className="module_heading module-heading-content">
            <ContentMaxWidth>
                {/* Heading  */}
                {heading && <Heading dangerouslySetInnerHTML={{ __html: heading }} />}

                {/* Copy */}
                {copy && (
                    <Copy
                        dangerouslySetInnerHTML={{
                            __html: copy
                        }}
                        extend={copyStyles}
                    ></Copy>
                )}
            </ContentMaxWidth>
        </Container>
    );
}

const Heading = createComponent(
    () => ({
        ...fonts.aeonikBold,
        extend: [fluid("fontSize", { min: 36, max: 100 })]
    }),
    "h3",
    ["dangerouslySetInnerHTML"]
);

const Copy = createComponent(
    () => ({
        ...textStyles.paragraphLarge,
        maxWidth: 800,
        marginH: "auto"
    }),
    "p",
    ["dangerouslySetInnerHTML"]
);

const copyStyles = {
    extend: [fluid("marginTop", { min: 20, max: 40 })]
};

const Container = createComponent(
    () => ({
        textAlign: "center",
        extend: [
            fluid("paddingV", gutters.vertical),
            fluid("paddingH", gutters.default)
        ]
    }),
    "div",
    ["id"]
);
